import { render, staticRenderFns } from "./StepAlreadyWebsite.vue?vue&type=template&id=21f9ad54&"
import script from "./StepAlreadyWebsite.vue?vue&type=script&lang=js&"
export * from "./StepAlreadyWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports